import React, { Component } from 'react'
import ContentHeader from '../../components/ContentHeader'
import ContentSidebar from '../../components/ContentSidebar'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
    get_tracks,
    toggle_add_track,
    add_track,
    delete_track,
    upload_track,
    handle_input_change,
    delete_track_file,
    reorder_tracks,
    reset_track,
    edit_track,
    update_track
} from '../../modules/music'
import '../../styles/css/music.css'
import Reorder from 'react-reorder'
// import DragSortableList from 'react-drag-sortable'

class Music extends Component {

    constructor(props) {
        super(props)
        this.state = {
            addMusicVisible: true,
            editTrackVisible: false,
            tracks: []
        }
    }

    componentDidMount = () => {
        this.props.get_tracks()
    }

    toggleAddMusic = () => { 
        this.setState({
            addMusicVisible: !this.state.addMusicVisible
        })
    }

    toggleEditTrack = (track = null) => {
        if(track === null) {
            this.props.reset
            return this.setState({ editTrackVisible: false })
        }
        this.props.edit_track(track)
        this.setState({
            editTrackVisible: !this.state.editTrackVisible
        })
    }

    handleUpdateTrack = e => {
        e.preventDefault()
        this.setState({ editTrackVisible: false })
        return this.props.update_track(this.props.track)
    }

    handleAddTrack = e => {
        e.preventDefault();
        const { track } = this.props
        if(!track.file) {
            return alert('no file uploaded')
        }
        this.props.add_track(track)
    }

    componentWillReceiveProps = nextProps => {
        this.setState({
            tracks: nextProps.tracks.sort(function(a, b){return a.order - b.order})
        })
    }

    handleUp = originalIndex => {
      let { tracks } = this.state
      tracks.filter((track,index) => {
          if(index === originalIndex - 1) {
            let originalOrder = tracks[originalIndex].order
            tracks[originalIndex].order = track.order
            track.order = originalOrder
            return track
        }
        return track
      })      
      this.setState({ tracks: tracks.sort(function(a, b){return a.order - b.order}) })
      this.props.reorder_tracks(this.state.tracks)
    }

    handleDown = originalIndex => {
        let { tracks } = this.state
        tracks.filter((track,index) => {
            if(index === originalIndex + 1) {
                let originalOrder = tracks[originalIndex].order
                tracks[originalIndex].order = track.order
                track.order = originalOrder
                return track
            }
            return track
        })      
        this.setState({ tracks: tracks.sort(function(a, b){return a.order - b.order}) })
        this.props.reorder_tracks(this.state.tracks)
    }

    Track = ({ item }) => (
        <tr>
            {/* <td>{index + 1}</td> */}
            <td>{item.title}</td>
            <td>{item.length}</td>
            <td><button onClick={() => this.toggleEditTrack(item)} className="edit">Edit</button><button onClick={() => this.props.delete_track(item._id)}>Delete</button></td>
        </tr>
    )

    callback = (event, itemThatHasBeenMoved, itemsPreviousIndex, itemsNewIndex, reorderedArray) => {
        let newArray = []
        reorderedArray.map((item,index) => {
          item.order = index
          newArray.push(item)
        })
        this.props.reorder_tracks(newArray)
    }
    
    render() {
        const { track, addTrackForm, uploading, update_track } = this.props
        const { delete_track, upload_track, handle_input_change, toggle_add_track, delete_track_file } = this.props
        const { tracks, editTrackVisible } = this.state
        return(
            <div id="content">
                            
                <ContentHeader 
                    title="Music"
                    buttonTitle="Add new"
                    buttonClick={toggle_add_track}
                />

                {addTrackForm && 
                    <Add 
                        track={track}
                        toggle={toggle_add_track} 
                        onAdd={this.handleAddTrack}
                        onUpload={upload_track}
                        onDeleteFile={delete_track_file}
                        onChange={handle_input_change}
                        uploading={uploading}
                    />
                }

                {editTrackVisible && 
                    <Edit 
                        track={track}
                        toggle={this.toggleEditTrack} 
                        onSave={this.handleUpdateTrack}
                        onUpload={upload_track}
                        onDeleteFile={delete_track_file}
                        onChange={handle_input_change}
                        uploading={uploading}
                    />
                }

                <div id="content-body">
                    <table className="tracks">
                        <tr>
                            <th>Title</th>
                            <th>Length</th>
                            <th>Options</th>
                            <th></th>
                        </tr>

                            <Reorder
                                itemKey='_id'
                                holdTime='200'
                                list={tracks}
                                template={this.Track}
                                callback={this.callback}
                                listClass=''
                                itemClass='reorder-track-container'
                                itemClicked={this.itemClicked}
                                selectedKey='uuid'
                                disableReorder={false}
                            />
                            
                    </table>

                </div>

            </div>
        )
    }

}

const Track = ({ track, index, tracksLength, onEdit, onDelete, onUp, onDown }) => (
    <tr>
        <td>{index + 1}</td>
        <td>{track.title}</td>
        <td>{track.length}</td>
        <td><button onClick={() => onEdit(track)} className="edit">Edit</button><button onClick={() => onDelete(track._id)}>Delete</button></td>
        <td className="reorder">
            {track.order !== 1 && <button onClick={() => onUp(index)} className="up"></button> }
            {track.order !== tracksLength && <button onClick={() => onDown(index)} className="down"></button> }
        </td>
    </tr>
)

const Add = ({ track, toggle, onAdd, onUpload, onDeleteFile, onChange, uploading }) => (
    <ContentSidebar title="Add new track" toggle={toggle}>
        <div>
            <label className={track.file ? 'upload success' : 'upload'}>
                <input type="file" accept=".mp3" onChange={onUpload} disabled={track.file ? true : false} required/>
                <span>
                    {uploading && <div className="loader"></div> }
                    {track.file && !uploading ? 'Track file uploaded' : 'Upload file (.mp3)'}
                    {track.file && <button onClick={() => onDeleteFile(track.file)} className="delete">&times;</button>}
                </span>
            </label>
            <form onSubmit={onAdd}>
                <input autoFocus onChange={onChange} name="title" type="text" placeholder="Title" />
                <input onChange={onChange} name="artist" type="text" placeholder="Artist(s)" />
                <input onChange={onChange} name="producer" type="text" placeholder="Producer" />
                <input onChange={onChange} name="writer" type="text" placeholder="Writer" />
                <input onChange={onChange} name="mixed_mastered" type="text" placeholder="Mix & Mastered" />
                <textarea onChange={onChange} name="lyrics" rows="5" cols="45" placeholder="Lyrics"></textarea>
                <button>Save</button>
            </form>
        </div>
    </ContentSidebar>
)

const Edit = ({ track, toggle, onSave, onUpload, onDeleteFile, onChange, uploading }) => (
    <ContentSidebar title="Editing existing track" toggle={toggle}>
        <div>
            <label className={track.file ? 'upload success' : 'upload'}>
                <input type="file" accept=".mp3" onChange={onUpload} disabled={track.file ? true : false} required/>
                <span>
                    {uploading && <div className="loader"></div> }
                    {track.file && !uploading ? 'Track file uploaded' : 'Upload file (.mp3)'}
                    {track.file && <button onClick={() => onDeleteFile(track.file)} className="delete">&times;</button>}
                </span>
            </label>
            <form onSubmit={onSave}>
                <input autoFocus onChange={onChange} value={track.title} name="title" type="text" placeholder="Title" />
                <input onChange={onChange} value={track.artist} name="artist" type="text" placeholder="Artist(s)" />
                <input onChange={onChange} value={track.producer} name="producer" type="text" placeholder="Producer" />
                <input onChange={onChange} value={track.writer} name="writer" type="text" placeholder="Writer" />
                <input onChange={onChange} value={track.mixed_mastered} name="mixed_mastered" type="text" placeholder="Mix & Mastered" />
                <textarea onChange={onChange} defaultValue={track.lyrics} name="lyrics" rows="5" cols="45" placeholder="Lyrics"></textarea>
                <button>Save changes</button>
            </form>
        </div>
    </ContentSidebar>
)

const mapStateToProps = ({ music: { tracks,track,error, addTrackForm, uploading } }) => ({
    tracks,
    track,
    error,
    addTrackForm,
    uploading
})

const mapDispatchToProps = dispatch => bindActionCreators({
    get_tracks,
    toggle_add_track,
    add_track,
    delete_track,
    upload_track,
    handle_input_change,
    delete_track_file,
    reorder_tracks,
    reset_track,
    edit_track,
    update_track
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Music)


// WEBPACK FOOTER //
// ./src/containers/music/index.js